export enum TicketProviderType {
    Email = 1,
    FourMe = 2,
}